import * as React from "react";

const cardStyle = {
  borderRadius: '0.75rem',
  border: '1px solid #e2e8f0',
  backgroundColor: 'white',
  color: '#0f172a',
  boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  transition: 'all 0.2s ease',
};

const Card = React.forwardRef(({ className, style, ...props }, ref) => (
  <div
    ref={ref}
    style={{ ...cardStyle, ...style }}
    {...props}
  />
));
Card.displayName = "Card";

const CardHeader = React.forwardRef(({ className, style, ...props }, ref) => (
  <div
    ref={ref}
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.375rem',
      padding: '1rem',
      ...style,
    }}
    {...props}
  />
));
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef(({ className, style, ...props }, ref) => (
  <h3
    ref={ref}
    style={{
      fontWeight: 600,
      lineHeight: 1,
      letterSpacing: '-0.01em',
      ...style,
    }}
    {...props}
  />
));
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef(({ className, style, ...props }, ref) => (
  <p
    ref={ref}
    style={{
      fontSize: '0.875rem',
      color: '#64748b',
      ...style,
    }}
    {...props}
  />
));
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef(({ className, style, ...props }, ref) => (
  <div 
    ref={ref} 
    style={{
      padding: '1rem',
      paddingTop: 0,
      ...style,
    }} 
    {...props} 
  />
));
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef(({ className, style, ...props }, ref) => (
  <div
    ref={ref}
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '1rem',
      paddingTop: 0,
      ...style,
    }}
    {...props}
  />
));
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
